<template>
     <el-dialog
     :title="title"
     :visible.sync="dialogVisible"
     width="45%"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
       <div class="panel">
           <el-form ref="proForm" :model="form" :rules="proFormRules" label-width="90px" size="small">
                <el-row :gutter="5">
                  <el-col :span="12">
                        <el-form-item label="产品名称">
                            <el-select
                                v-model="productName"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                                @change="productNameChange"
                            >
                                <el-option
                                v-for="item in productList"
                                :key="item._id"
                                :label="item.productName"
                                :value="item._id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="产品编号">
                          <el-input size="small" v-model="form.productCode" placeholder="输入产品编号" readonly></el-input>


                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="产品规格" prop="specs">
                            <el-input size="small" v-model="form.specs" placeholder="输入产品规格" readonly></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="工序名称">
                            <el-select
                                v-model="form.processCode"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                                @change="processChange"
                            >
                                <el-option
                                v-for="item in processList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="计价方式">
                            <el-select
                                v-model="form.countBy"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                            >
                                <el-option
                                v-for="item in countByList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="报工类型">
                            <el-select
                                v-model="form.countType"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                            >
                                <el-option
                                v-for="item in countTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="工资单价" prop="unitPrice">
                          <el-input-number v-model="form.unitPrice" controls-position="right"  size="small" :min="1" :max="9007199254740991" style="width:100%"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item  prop="customName">
                            <span slot="label">
                                标准效率
                                <el-tooltip class="item" effect="dark" content="设置标准工时，先编辑时间，个数自动填充1；设置标准时产，先编辑个数，时间自动填充1小时；填充可再编辑" placement="top">
                                    <i class='el-icon-question' ></i>
                                </el-tooltip>
                            </span>
                            <el-input-number v-model="form.standardCapacity[0]" controls-position="right" :min="0"  placeholder="产出" class="num1" size="small" @change="standardCapacityChange('count')"></el-input-number>
                            /<span>{{form.standardCapacity[1] + '小时'}}</span>
                            <!-- <el-input-number disabled v-model="form.standardCapacity[1]" controls-position="right"  :min="0"  class="num2" size="small" @change="standardCapacityChange('time')"></el-input-number>
                            小时 -->
                            <!-- <el-input-number v-model="form.standardCapacity[2]" controls-position="right"  :min="0"  class="num2" size="small" @change="standardCapacityChange('time')"></el-input-number>
                            分钟 -->
                            <!-- <el-input-number v-model="form.standardCapacity4" controls-position="right"  :min="1" :max="10" class="num2" size="small"></el-input-number>
                            秒 -->
                        </el-form-item>
                    </el-col>
                </el-row>
           </el-form>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import { salarySetSave, productGetAll,processGetAll,technologyGetAllProcess} from '@/api/basicData'
export default {
    name:'createPerformAllocation',
    props:{
        userData:{
          type:Object,
          default:{},
        },
        editRow:{
          type:Object,
          default:{},
        },
        mode:{
          type:String,
          default:'',
        },
    },
    data(){
      var checkUnitPrice = (rulr,value,callback) =>{
        var copyValue = value + ''
        if(value<=0){
          callback('工资单价必须大于0')
        }else{
          var arr = copyValue.split('.')
          if(arr.length == 2){
            if(arr[0].length > 10){
              callback('整数位最多支持10位数字')
            }else{
              if(arr[1].length > 6){
                callback('小数点后最多保留6位数字')
              }else{
                callback()
              }
            }
          }else if(arr.length == 1){
            if(arr[0].length > 10){
              callback('整数位最多支持10位数字')
            }else{
              callback()
            }
          }else{

          }
        }
      }
        return{
            dialogVisible: false,
            form:{
              unitPrice:'',
              standardCapacity:[0,1]
            },
            proFormRules:{
                unitPrice:[{
                  required: true,
                  message: "请输入工资单价",
                  trigger: ['blur','change'],
              },{validator:checkUnitPrice, trigger: ['blur','change']}] ,
            },
            countByList: [
                {
                    label: "计时",
                    value: "计时"
                },
                {
                    label: "计件",
                    value: "计件"
                },
            ],
            countTypeList: [
                {
                    label: "正常报工",
                    value: "正常报工"
                },
                {
                    label: "返工报工",
                    value: "返工报工"
                },
            ],
            productList:[],
            processList:[],
            productName:'',
            title:'创建绩效工资配置'
        }
    },
    created(){
      this.dialogVisible = true
      if(this.mode == 'edit'){
        this.title = '编辑绩效工资配置';
        this.form = JSON.parse(JSON.stringify(this.editRow));
        this.form.standardCapacity = this.form.standardCapacity?this.form.standardCapacity:[0,1];
      }
      this.productAll()
      //this.processAll()
    },
    methods:{
      standardCapacityChange(type){
        // if(type == 'count'){
        //   if((!this.form.standardCapacity[1] || this.form.standardCapacity[1] == 0)
        //   && (!this.form.standardCapacity[2] || this.form.standardCapacity[2] == 0)){
        //     this.form.standardCapacity[1] = 1;
        //   }
        // }
        // if(type == 'time'){
        //   if(!this.form.standardCapacity[0] || this.form.standardCapacity[0] == 0){
        //     this.form.standardCapacity[0] = 1;
        //   }
        // }
      },
      processChange(val){
        this.form.processName = this.processList.filter(item=>item.value == val)[0].label;
      },
      productNameChange(val){
        var list = this.productList.filter(item=>item._id == val);
        if(list && list.length > 0){
          var product = list[0];
          this.form.productCode = product.productCode;
          this.form.productName = product.productName;
          this.form.specs = product.specs;
          this.processAll(product.technologyCode);
        }else{
          this.form.productCode = '';
          this.form.productName = '';
        }
      },
      handleSave(){
        this.$refs.proForm.validate((valid) => {
            if (valid) {
              var data = JSON.parse(JSON.stringify(this.form));
              data.factoryId = this.userData.factoryId,
              salarySetSave(data).then(res => {
                if(res.code == 200){
                  this.$message.success('保存成功')
                  this.$emit('done',{type:'save'})
                  this.dialogVisible = false;
                }else{
                  this.$message.error(res.msg)
                }
              }).catch(err => {
                this.$message.error(err)
              })
            }
        })
      },

      closeDialog(){
          setTimeout(() => {
              this.dialogVisible = false;
              this.$parent.createProductPanVisible = false;
          }, 100);
      },
      productAll(){
        productGetAll(this.userData.factoryId).then(res => {
          if(res.code == 200){
            this.productList = res.data;

            let data = this.productList.filter(item=>item.productCode == this.form.productCode);
            if(data.length>0){
              this.productName = data[0]._id;
              this.processAll(data[0].technologyCode);

            }

          }else{
            this.$message.error('查询失败！')
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
      },
      processAll(techCode){

        technologyGetAllProcess(techCode,this.userData.factoryId).then(res=>{
          if(res.code == 200){
            var data = JSON.parse(JSON.stringify(res.data))
            this.processList = data.map(function(item){
              return {
                value:item.processCode === undefined ?'':item.processCode,
                label:item.processName,
                _id:item._id,
              }
            })
          }else{
            this.$message.error('查询失败！')
          }
        });

        // processGetAll(this.userData.factoryId).then(res => {
        //   if(res.code == 200){
        //     var data = JSON.parse(JSON.stringify(res.data))
        //     this.processList = data.map(function(item){
        //       return {
        //         value:item.processCode === undefined ?'':item.processCode,
        //         label:item.processName,
        //         _id:item._id,
        //       }
        //     })
        //   }else{
        //     this.$message.error('查询失败！')
        //   }
        // })
        // .catch(err => {
        //   this.$message.error(err)
        // })
      },
    }

}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        /* height: 45vh; */
        overflow-y: auto;
        overflow-x: hidden;
        /* padding: 0px 50px; */
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }
    .num1{
        width: calc(100% - 415px);
    }
    .num2{
        width: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/views/basicData/performAllocation/createPerformAllocation.vue